import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CategoryService } from '../../../../../services/category.service';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { categoryModel } from '../models/category.model';
@Component({
  selector: 'app-create-edit-category',
  templateUrl: './create-edit-category.component.html',
  styleUrls: ['./create-edit-category.component.scss']
})
export class CreateEditCategoryComponent implements OnInit {
  @Input() data: any = {};
  formGroup: RxFormGroup;
  isEdit = false;
  fields: any ={
    name: {
      type: 'input',
      options: {
        path: 'name',
        class: 'col-sm-12',
        label:{
          text: 'Nombre',
          class: 'col-sm-12'
        }
      }
    },description: {
			type: 'textarea',
			options: {
				path: 'description',
				class: 'col-sm-12',
				label: {
					text: 'Descripcion',
					class: 'col-sm-12'
				}
			}
		}
  }
 private atComponentDestroy = new Subject();
 
   constructor(
     private cdr: ChangeDetectorRef,
     public modalRef: BsModalRef,
     private categoryService: CategoryService,
     private broadcast: BroadcastService,
     private formService: FormService
   ) {
     this.formService._formEvents
       .pipe(takeUntil(this.atComponentDestroy))
       .subscribe(form => {
         this.formGroup = form;
         this.cdr.detectChanges();
       });
   }
 
   ngOnDestroy(): void {
     this.atComponentDestroy.next();
     this.atComponentDestroy.unsubscribe();
   }
 
   ngOnInit(): void {
     this.formService.transformIntoFormGroup(categoryModel, this.data);
 
     if (this.data?.id) {
       this.isEdit = true;
       this.formGroup.get('description').setValue(this.data.description);
       this.formGroup.get('name').setValue(this.data.name);
     }
     this.formGroup.valueChanges
     .pipe(takeUntil(this.atComponentDestroy))
     .subscribe(data => {
       this.cdr.markForCheck();
     });
   }
 
   submit(): void {
     this.categoryService.createOrUpdate(this.formGroup, this.data?.id)
       .pipe(takeUntil(this.atComponentDestroy))
       .subscribe(data => {
         this.broadcast.reloadDataTable();
         this.modalRef.hide();
       }, error => {
         console.error("Error al enviar los datos:", error);
       });
   }
   
   toArray(enumme): any[] {
    return Object.keys(enumme)
      .map(key => ({ id: key, name: enumme[key] }));
  }
 }